/// <amd-module name="Dashboards/CommonConfig/SeparatedSizePicker" />
import * as Resources from "Dashboards/CommonConfig/Resources";
import * as React from "react";
import { IVssComponentContext, VssComponent } from "VSS/Platform/Layout";
import { ComboBox, IComboBoxOption } from "VSSUI/ComboBox";
import { InlineError } from "./InlineError";
import { SizePickerProps } from "./SizePicker.props";

export interface SeparatedSizePickerProps extends SizePickerProps {
    /** A Map of available hwidth choices to corresponding available height choices. */
    widthToHeightsMap: { [key: string]: string[] };
}

/**
 *  A size picker factored for reuse with Widget Confuration experiences and legacy Widget Host.
 * */
export class SeparatedSizePicker extends VssComponent<SeparatedSizePickerProps> {
    constructor(props: SeparatedSizePickerProps, context: IVssComponentContext) {
        super(props, context);
        this.state = { widthToHeightsMap: {} };
    }

    public render(): JSX.Element {
        const sizeMap = this.props.widthToHeightsMap;
        const widths = Object.keys(sizeMap).sort((x, y) => +x - +y);
        const widthComboValues = widths.map(x => {
            return { text: x, key: x };
        });
        const selectedWidthKey = this.props.value && this.props.value.columnSpan.toLocaleString();
        const heights = sizeMap[selectedWidthKey] || [];
        const heightComboValues = heights.map(x => {
            return { text: x, key: x };
        });
        const selectedHeightKey = this.props.value && this.props.value.rowSpan.toLocaleString();
        const hasAtLeastOneOption = this.props.sizes.length > 1;

        return (
            <>
                {hasAtLeastOneOption && (
                    <>
                        <div className="config-width-and-height-pickers">
                            <ComboBox
                                className="config-width-picker config-dimension-picker"
                                label={Resources.WidthControlLabel}
                                ariaLabel={Resources.WidthControlLabel}
                                options={widthComboValues}
                                onChanged={this.onChangeWidth}
                                selectedKey={selectedWidthKey}
                            />
                            <ComboBox
                                className="config-height-picker config-dimension-picker"
                                label={Resources.HeightControlLabel}
                                ariaLabel={Resources.HeightControlLabel}
                                options={heightComboValues}
                                onChanged={this.onChangeHeight}
                                selectedKey={selectedHeightKey}
                            />
                        </div>
                        <InlineError />
                    </>
                )}
            </>
        );
    }

    private onChangeWidth = (option?: IComboBoxOption, index?: number, value?: string, submitPendingValueEvent?: any): void => {
        const selectedEntry: string | undefined = option && option.key.toLocaleString();
        if (selectedEntry) {
            this.props.onChange({
                columnSpan: +selectedEntry,
                rowSpan: this.props.value.rowSpan
            });
        }
    };

    private onChangeHeight = (option?: IComboBoxOption, index?: number, value?: string, submitPendingValueEvent?: any): void => {
        const selectedEntry: string | undefined = option && option.key.toLocaleString();
        if (selectedEntry) {
            this.props.onChange({
                columnSpan: this.props.value.columnSpan,
                rowSpan: +selectedEntry
            });
        }
    };
}
